module.exports = __webpack_public_path__ + "static/media/119042.e39d8dd4.svg";